"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const enums_1 = require("../../enums");
class MakeOfferRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({ example: base_models_1.Brand.ESSENT, description: 'Brand the make offer request is for' }),
    tslib_1.__metadata("design:type", String)
], MakeOfferRequest.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: '7972b7f3-7279-43b1-88af-d7643ad7976e', description: 'The id of this proposition.' }),
    tslib_1.__metadata("design:type", String)
], MakeOfferRequest.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7', description: 'Profile identifier' }),
    tslib_1.__metadata("design:type", String)
], MakeOfferRequest.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '1234AB_56_C', description: 'Address the offer is intended for' }),
    (0, base_models_1.IsAddressKey)(),
    tslib_1.__metadata("design:type", String)
], MakeOfferRequest.prototype, "deliveryAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Channel)),
    (0, base_models_1.Docs)({ example: enums_1.Channel.MIJN, description: 'Channel is read from apiKey. This property is for internal testing only.' }),
    tslib_1.__metadata("design:type", String)
], MakeOfferRequest.prototype, "channel", void 0);
exports.default = MakeOfferRequest;
